import React from 'react';
import { Container, Nav, Navbar, Button } from 'react-bootstrap';
import { Link, useLocation } from 'react-router-dom';

import { HashLink } from 'react-router-hash-link';
import './Header.css';

const Header = () => {
  const location = useLocation();

  const activeNav = location?.pathname?.slice(1);

  return (
    <Navbar
      collapseOnSelect
      expand='lg'
      variant='dark'
      className='p-3 bg-dark bg-gradient'
    >
      <Container>
        <Link to='/'>
          <Navbar.Brand className='fs-3  fst-italic text-white fw-light'>
            <i className='fas fa-user-tie'></i>&nbsp;Tanvir's Portfolio
          </Navbar.Brand>
        </Link>

        <Navbar.Toggle aria-controls='responsive-navbar-nav' />
        <Navbar.Collapse id='responsive-navbar-nav'>
          <Nav className='ms-auto'>
            <HashLink className='me-5 nav-link text-white' to='/home'>
              <span
                className={`nav-text ${
                  activeNav === 'home' ? 'active-nav-text' : ''
                }`}
              >
                Home
              </span>
            </HashLink>

            <HashLink className='me-5 nav-link text-white' to='/about'>
              <span
                className={`text-nowrap nav-text ${
                  activeNav === 'about' ? 'active-nav-text' : ''
                }`}
              >
                About Me
              </span>
            </HashLink>

            <HashLink className='me-5 nav-link text-white ' to='/skills'>
              <span
                className={`nav-text ${
                  activeNav === 'skills' ? 'active-nav-text' : ''
                }`}
              >
                Skills
              </span>
            </HashLink>

            <HashLink className='me-5 nav-link text-white ' to='/allProjects'>
              <span
                className={`nav-text ${
                  activeNav === 'allProjects' ? 'active-nav-text' : ''
                }`}
              >
                Projects
              </span>
            </HashLink>

            <HashLink className='me-5 nav-link text-white ' to='/blogs'>
              <span
                className={`nav-text ${
                  activeNav === 'blogs' ? 'active-nav-text' : ''
                }`}
              >
                Blogs
              </span>
            </HashLink>

            <HashLink className='me-5 nav-link text-white ' to='/contact'>
              <span
                className={`nav-text ${
                  activeNav === 'contact' ? 'active-nav-text' : ''
                }`}
              >
                Contact
              </span>
            </HashLink>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default Header;
